import moment from 'moment-timezone';
import type { ReactNode } from 'react';

import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type BusinessHoursNode = ConversationFlowAuditLogEntry<
  'EMAIL_BUSINESS_HOURS_NODE_VISITED' | 'TELEPHONY_BUSINESS_HOURS_NODE_VISITED'
>;

type RoutedThroughBusinessHoursProps = {
  node: BusinessHoursNode;
};

function getScheduleText(node: BusinessHoursNode): ReactNode {
  if (!node.interval) {
    return null;
  }

  if (node.is_open) {
    return `from ${node.interval.start_time} - ${node.interval.end_time}`;
  }

  const format = 'HH:mm';

  const timestamp = moment.utc(node.event_timestamp).format(format);
  const actionTime = moment.utc(timestamp, format);
  const startTime = moment.utc(node.interval.start_time, format);

  if (actionTime.isBefore(startTime)) {
    return `before ${node.interval.start_time}`;
  }

  return `after ${node.interval.end_time}`;
}

export function RoutedThroughBusinessHours({
  node,
}: RoutedThroughBusinessHoursProps): JSX.Element {
  return (
    <>
      Business hours · <strong>{node.is_open ? 'Open' : 'Closed'}</strong> on{' '}
      {node.business_hour_name} {getScheduleText(node)}
    </>
  );
}
